export default {
    title: 'Custom Table',
    'title-plural': 'Custom Tables',
    create: 'Create Table',
    import: {
        button: 'Import from JSON',
        title: 'Import Custom Table from JSON',
        paste: 'Paste JSON here...',
    },
    'configure-record-view': 'Configure Record Views',
    'show-records': 'Show Records',
    'export-tables': 'Export Custom Tables',
    'import-record-view': {
        title: 'Import Record View Configuration',
        'upload-label': 'Import via JSON file',
        'upload-description': 'Upload a JSON file containing your record view configuration',
        'paste-label': 'Paste JSON here...',
        'editor-label': 'Record view',
    },
    fields: {
        fields: 'Fields',
        'relation-fields': 'Relation Fields',
        'add-relation-fields-info': 'Relation Fields can be defined once the relation has been created.',
        title: 'Objects',
        create: 'Add object',
        'edit-field': 'Edit field',
        'add-field': 'Add field',
        'search-fields': 'Search fields',
        empty: 'No fields found.',
        import: {
            button: 'Import',
            title: 'Import Fields from JSON',
            'upload-label': 'Import via JSON file',
            'upload-description': 'Upload a JSON file containing field definitions',
            'paste-label': 'Paste JSON here...',
            'editor-label': 'Fields',
            summary: 'Imported {imported} field(s). Skipped: {skipped}',
        },
    },
    'add-field': {
        icon: 'Icon',
        type: 'Type',
        name: 'Name',
        label: 'Label',
        readonly: 'Readonly',
        'readonly-deprecated': 'The readonly setting has been deprecated in favor of per-field level permissioning and is no longer available.',
        'default-value': 'Default value',
        'default-current-date': 'Default to Current Date',
        'default-current-date-time': 'Default to Current Date and Time',
        'default-checkbox': 'Selected',
        'default-single-select': 'Default option',
        'default-multi-select': 'Default options',
        'state-machine': 'State machine',
        'max-length': 'Max length',
        autoincrement: 'Autoincrement',
        'button-name': 'Button name',
        'button-label': 'Button Label',
        workflow: 'Workflow',
        'select-workflow': 'Select workflow',
    },
    'delete-selected-fields': 'Delete selected fields',
    'delete-selected-relations': 'Delete selected relations',
    'on-off-options': {
        yes: 'Yes',
        no: 'No',
    },
    'create-new': 'Create New Custom Table',
    edit: 'Edit {name}',
    empty: 'No tables found.',
    name: 'Name',
    'label-singular': 'Label Singular',
    'label-plural': 'Label Plural',
    description: 'Description',
    'record-label': 'Record Label',
    actions: 'Actions',
    'table-view': {
        'add-new': 'Add new {name}',
        'table-not-editable': 'Add new field to the custom table to make it editable',
    },
    relations: {
        title: 'Relations',
        add: 'Add relation',
        icon: 'Icon',
        type: 'Type',
        name: 'Name',
        label: 'Label',
        table: 'Table',
        'relation-type': 'Relation Type',
        'one-to-many': 'One to Many',
        'many-to-one': 'Many to One',
        'many-to-many': 'Many to Many',
        'one-to-one': 'One to One',
        'table-id': 'Select custom table',
        edit: 'Edit relation',
        empty: 'No relations found.',
        display: 'Display',
    },
    attachments: {
        title: 'Attachments',
    },
    kanban: {
        'illegal-transition': 'Can\'t move from "{from}" to "{to}" - that transition isn\'t defined on this state machine.',
    },
    graph: {
        title: 'Relations',
    },
    tabs: {
        tables: 'Tables',
        graph: 'Table Graph',
    },
    'table-graph': {
        empty: 'No relations to display',
        'show-junction-tables': 'Show junction tables',
    },
    'configure-record': {
        'add-field': 'Add field',
        'edit-field': 'Edit field',
        'relation-fields': {
            title: 'Configure Relation Fields',
        },
        errors: {
            name: 'Record view name is required.',
            fields: 'At least one field is required.',
            relations: 'At least one relation is required.',
            'relation-fields': 'Relation fields are required.',
        },
        'confirm-delete': 'Are you sure you want to delete this configuration?',
        'link-visibility': {
            label: 'Link visibility',
            hover: 'On hover',
            always: 'Always',
        },
    },
    'default-record-view': 'Show default view',
    'custom-record-view': 'Show {name}',
    'configure-graph': {
        title: 'Configure Graph',
        nodes: 'Nodes',
        links: 'Links',
        fields: 'Visible fields',
        errors: {
            'no-tables': 'No tables defined in the workspace.',
            fields: 'At least one field is required.',
        },
        'confirm-delete': 'Are you sure you want to delete this configuration?',
    },
    'activity-log': {
        truncated: 'This record is related to too many entries to show them all. Narrow the results to see the full history.',
        'search-own-events-only': 'Search for own events only',
        scope: 'Events',
        'events-scope-all': 'Whole graph',
        'events-scope-own': 'Own events only',
    },
    'state-machine': {
        'select-placeholder': 'Select a state machine',
        edit: 'Edit',
        create: 'Create new',
        'modal-edit-title': 'Edit state machine',
        'modal-create-title': 'Create state machine',
        name: 'Name',
        states: 'States',
        'state-value-placeholder': 'Value',
        'state-color-placeholder': 'Color',
        'state-icon-placeholder': 'Icon',
        'add-state': 'Add state',
        transitions: 'Transitions',
        'load-failed': 'Failed to load state machine',
        'terminal-state': 'Terminal state',
        'terminal-state-tooltip': 'This state has no further transitions.',
    },
    batch: {
        edit: 'Batch edit',
        'edit-tooltip': 'Select and batch edit records',
        select: 'Select records',
        'edit-header': 'Batch edit {count} records',
        selected: 'selected',
        'edit-description': 'Only fields you set a value for below will be applied to all {count} selected records. Fields left blank stay unchanged.',
        'edit-empty-fields': 'No editable fields found',
        'update-success': 'Updated {count} record(s)',
        'update-failed': 'Failed to update {count} record(s)',
        comment: {
            title: 'Add comment',
            'batch-title': 'Comment on batch change',
            saved: 'Comment added successfully',
        },
    },
}
